import { isSignedIn } from '@dacr/auth'
import {
  useFeatureFlagStore,
  type FeatureFlag,
} from '@/shared/stores/featureFlags'
import type { NavigationGuard } from 'vue-router'

export const authGuard: NavigationGuard = (_, __, next) => {
  if (isSignedIn()) {
    next()
  } else {
    next('/login')
  }
}

export const featureFlagGuard = (
  flag: FeatureFlag,
  fallback = '/home'
): NavigationGuard => {
  return async (_, __, next) => {
    const store = useFeatureFlagStore()
    await store.waitForFlags()

    if (store.isEnabled(flag)) {
      next()
    } else {
      next(fallback)
    }
  }
}
